<template>
  <div :class="$vuetify.breakpoint.mdAndDown ? 'pt-0 pb-4' : 'py-4'">
    <div v-if="matchesHighlights.length > 0">
      <v-row no-gutters class=" pb-4 matches-header" align="end">
        <v-col cols="10">
          {{ $t(`label.upComingMatches`) }}
        </v-col>
        <v-col v-if="!$vuetify.breakpoint.lgAndUp" cols="2" class="text-right">
          <v-btn color="black" text height="auto" class="text-capitalize pr-0 body-2 text-decoration-underline" :to="{ name: routeName.CRICKET }">
            {{ $t(`button.more`) }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-row class="pa-2">
      <!--        <v-col cols="12" class="bg-ambas d-flex pa-0">-->
      <v-col cols="12" :class="$vuetify.breakpoint.lgOnly ? 'tabHeight' : ''" class="pa-0 bg-ambas" v-if="isImageLoaded" :style="{ backgroundImage: 'url(' + currentBackgroundImage + ')' }">
        <v-col cols="12" class="col-md-7 ambas">
          <v-img :src="`${mediaUrl}/banner/BB88_mobile.png`" class="hidden-md-and-up banner-img" style="height: 100%; width: 100%;"></v-img>
          <div class="carousel-controls">
            <button v-for="(image, index) in images" :key="index" @click="selectImage(index)" :class="{ active: index === currentIndexes }" class="control-dot"></button>
          </div>
        </v-col>
        <v-col cols="12" class="align-center col-md-5 d-flex ambas-vid">
          <div class="iframe-box">
            <iframe
              :src="currentVideoSource"
              width="100%"
              height="100%"
              style="border: none; overflow: hidden; border-radius: 10px; aspect-ratio: 16/9"
              scrolling="no"
              frameborder="0"
              allowfullscreen="false"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            ></iframe>
          </div>
        </v-col>
      </v-col>
    </v-row>
    <v-row no-gutters justify="center" class="mx-0" v-if="cricketMatches.length > 0">
<!--    <v-row no-gutters justify="center" class="mx-0" v-if="false">-->
      <!-- desktop view-->
      <!--      <v-col cols="12" class="pt-2 highlights-container-desktop hidden-sm-and-down">-->
      <!--        <div class="matches-box">-->
      <!--          <div class="match-item" v-for="(league, index) in matchesHighlights" :key="index">-->
      <!--            &lt;!&ndash; <v-img width="200" height="200" class="game-card-image-avatar" src="https://cdn.pixabay.com/photo/2020/07/12/07/47/bee-5396362_1280.jpg" alt/> &ndash;&gt;-->
      <!--            <v-row no-gutters class="flex-nowrap">-->
      <!--              <v-col cols="12">-->
      <!--                <v-row no-gutters>-->
      <!--                  <v-col>-->
      <!--                    &lt;!&ndash; custom class for 1st and last to have border radius-->
      <!--                     :class="index == 0 ? 'border-top-left-radius' : index == matchesHighlights.length - 1 ? 'border-top-right-radius' : ''"-->
      <!--                     &ndash;&gt;-->
      <!--                    <v-card-->
      <!--                        class="pa-2 font-weight-bold cricket-name-header border-top-left-radius border-top-right-radius"-->
      <!--                        dark-->
      <!--                        outlined-->
      <!--                        tile-->
      <!--                    >-->
      <!--&lt;!&ndash;                      <v-icon dense class=" mb-1 mr-3">emoji_events</v-icon>&ndash;&gt;-->
      <!--                      <span style="color: #000;">{{ league.league_name }}</span>-->
      <!--                    </v-card>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--                <v-row no-gutters>-->
      <!--                  <v-col cols="9">-->
      <!--                    <v-card-->
      <!--                        light-->
      <!--                        class="pa-2 grey lighten-4"-->
      <!--                        outlined-->
      <!--                        tile-->
      <!--                    >-->
      <!--                      {{ league.home_team }}-->
      <!--                    </v-card>-->
      <!--                  </v-col>-->
      <!--                  <v-col cols="3">-->
      <!--                    <v-card-->
      <!--                        light-->
      <!--                        class="pa-2 grey lighten-4"-->
      <!--                        outlined-->
      <!--                        tile-->
      <!--                    >-->
      <!--                      {{ parseFloat(league.home_odds).toFixed(2) }}-->
      <!--                    </v-card>-->
      <!--                  </v-col>-->
      <!--                  <v-col cols="9">-->
      <!--                    <v-card-->
      <!--                        light-->
      <!--                        class="pa-2 grey lighten-4"-->
      <!--                        outlined-->
      <!--                        tile-->
      <!--                    >-->
      <!--                      {{ league.away_team }}-->
      <!--                    </v-card>-->
      <!--                  </v-col>-->
      <!--                  <v-col cols="3">-->
      <!--                    <v-card-->
      <!--                        light-->
      <!--                        class="pa-2 grey lighten-4"-->
      <!--                        outlined-->
      <!--                        tile-->
      <!--                    >-->
      <!--                      {{ parseFloat(league.away_odds).toFixed(2) }}-->
      <!--                    </v-card>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--                <v-row no-gutters>-->
      <!--                  <v-col cols="12">-->
      <!--                    <v-card-->
      <!--                        light-->
      <!--                        class="pa-2 grey lighten-4 border-bottom-left-radius border-bottom-right-radius"-->
      <!--                        outlined-->
      <!--                        tile-->
      <!--                    >-->
      <!--                      <v-row no-gutters>-->
      <!--                        <v-col cols="9">-->
      <!--                          {{ league.match_date }}-->
      <!--                        </v-col>-->
      <!--                        <v-col cols="3" class="text-right">-->
      <!--                          <v-btn color="black"-->
      <!--                                 class="primary-button embedded-mobile-login-button font-weight-bold yellow&#45;&#45;text"-->
      <!--                                 :to="{ name: routeName.CRICKET }">{{ $t(`button.betNow`) }}-->
      <!--                          </v-btn>-->
      <!--                        </v-col>-->
      <!--                      </v-row>-->
      <!--                    </v-card>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </v-col>-->
      <!--            </v-row>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </v-col>-->
      <!--      desktop-->
      <!--      <v-row no-gutters class="align-center pt-4" v-if="!$vuetify.breakpoint.smAndDown">-->
      <!--        <div class="d-flex justify-center">-->
      <!--          <v-btn class="circle-btn" @click="scrollLeft" :disabled="!matchesHighlightsDesktop.showPrev">-->
      <!--            <v-icon color="#fff">mdi-chevron-left</v-icon>-->
      <!--          </v-btn>-->
      <!--        </div>-->
      <!--        <v-col cols="11" class="pt-2 highlights-container-desktop hidden-sm-and-down">-->
      <!--          <div class="matches-box">-->
      <!--            <div class="highlights-container-desktop" ref="container">-->
      <!--              <div class="item" v-for="(league, index) in matchesHighlightsDesktop.currentMatches" :key="index">-->
      <!--                &lt;!&ndash; Display match information here &ndash;&gt;-->
      <!--                <v-row no-gutters class="flex-nowrap elevation-4" style="border-radius: 10px;">-->
      <!--                  <v-col cols="12">-->
      <!--                    <v-row no-gutters>-->
      <!--                      <v-col>-->
      <!--                        &lt;!&ndash; custom class for 1st and last to have border radius-->
      <!--                         :class="index == 0 ? 'border-top-left-radius' : index == matchesHighlights.length - 1 ? 'border-top-right-radius' : ''"-->
      <!--                         &ndash;&gt;-->
      <!--                        <v-card class="pa-2 font-weight-bold cricket-name-header border-top-left-radius border-top-right-radius" dark outlined tile>-->
      <!--                          &lt;!&ndash;                      <v-icon dense class=" mb-1 mr-3">emoji_events</v-icon>&ndash;&gt;-->
      <!--                          <span style="color: #000; font-size: 13px;">{{ league.league_name }} . {{ formatMatchDate(league.match_date) }}</span>-->
      <!--                        </v-card>-->
      <!--                      </v-col>-->
      <!--                    </v-row>-->
      <!--                    <v-row no-gutters class="pa-2 grey lighten-4 border-bottom-left-radius border-bottom-right-radius">-->
      <!--                      <v-col cols="9">-->
      <!--                        <v-card light class="pa-2 grey lighten-4 d-flex align-center" style="height: 100%; gap: 10px;" outlined tile>-->
      <!--                          <img :src="league.home_logo" height="25" width="25" />-->
      <!--                          {{ league.home_team }}-->
      <!--                        </v-card>-->
      <!--                      </v-col>-->
      <!--                      &lt;!&ndash;                      <v-col cols="3">&ndash;&gt;-->
      <!--                      &lt;!&ndash;                        <v-card&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          light&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          class="pa-2 text-center grey lighten-4"&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          style="height: 100%;"&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          outlined&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          tile&ndash;&gt;-->
      <!--                      &lt;!&ndash;                        >&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          {{ parseFloat(league.home_odds).toFixed(2) }}&ndash;&gt;-->
      <!--                      &lt;!&ndash;                        </v-card>&ndash;&gt;-->
      <!--                      &lt;!&ndash;                      </v-col>&ndash;&gt;-->
      <!--                      <v-col cols="9">-->
      <!--                        <v-card light class="pa-2 grey lighten-4 d-flex align-center" style="height: 100%; gap: 10px;" outlined tile>-->
      <!--                          <img :src="league.away_logo" height="25" width="25" />-->
      <!--                          {{ league.away_team }}-->
      <!--                        </v-card>-->
      <!--                      </v-col>-->
      <!--                      &lt;!&ndash;                      <v-col cols="3">&ndash;&gt;-->
      <!--                      &lt;!&ndash;                        <v-card&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          light&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          class="pa-2 text-center grey lighten-4"&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          style="height: 100%;"&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          outlined&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          tile&ndash;&gt;-->
      <!--                      &lt;!&ndash;                        >&ndash;&gt;-->
      <!--                      &lt;!&ndash;                          {{ parseFloat(league.away_odds).toFixed(2) }}&ndash;&gt;-->
      <!--                      &lt;!&ndash;                        </v-card>&ndash;&gt;-->
      <!--                      &lt;!&ndash;                      </v-col>&ndash;&gt;-->
      <!--                    </v-row>-->
      <!--                    &lt;!&ndash;                    <v-row no-gutters>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                      <v-col cols="12">&ndash;&gt;-->
      <!--                    &lt;!&ndash;                        <v-card&ndash;&gt;-->
      <!--                    &lt;!&ndash;                          light&ndash;&gt;-->
      <!--                    &lt;!&ndash;                          class="pa-2 grey lighten-4 border-bottom-left-radius border-bottom-right-radius"&ndash;&gt;-->
      <!--                    &lt;!&ndash;                          outlined&ndash;&gt;-->
      <!--                    &lt;!&ndash;                          tile&ndash;&gt;-->
      <!--                    &lt;!&ndash;                        >&ndash;&gt;-->
      <!--                    &lt;!&ndash;                          <v-row no-gutters>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                            <v-col cols="9">&ndash;&gt;-->
      <!--                    &lt;!&ndash;                              {{ league.match_date }}&ndash;&gt;-->
      <!--                    &lt;!&ndash;                            </v-col>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                            <v-col cols="3" class="text-right">&ndash;&gt;-->
      <!--                    &lt;!&ndash;                              <v-btn color="black"&ndash;&gt;-->
      <!--                    &lt;!&ndash;                                     class="primary-button embedded-mobile-login-button font-weight-bold yellow&#45;&#45;text"&ndash;&gt;-->
      <!--                    &lt;!&ndash;                                     :to="{ name: routeName.CRICKET }">{{ $t(`button.betNow`) }}&ndash;&gt;-->
      <!--                    &lt;!&ndash;                              </v-btn>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                            </v-col>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                          </v-row>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                        </v-card>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                      </v-col>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                    </v-row>&ndash;&gt;-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </v-col>-->
      <!--        <div class="d-flex justify-center">-->
      <!--          <v-btn class="circle-btn" @click="scrollRight" :disabled="!matchesHighlightsDesktop.showNext">-->
      <!--            <v-icon color="#fff">mdi-chevron-right</v-icon>-->
      <!--          </v-btn>-->
      <!--        </div>-->
      <!--      </v-row>-->
      <!-- mobile view-->
      <v-col cols="12" class=" highlights-container" :class="$vuetify.breakpoint.mdAndDown ? 'pt-2 pb-1' : 'pt-8 pb-3'">
        <div class="matches-box">
          <div class="match-item" v-for="(league, index) in cricketMatches" :key="index">
            <!-- <v-img width="200" height="200" class="game-card-image-avatar" src="https://cdn.pixabay.com/photo/2020/07/12/07/47/bee-5396362_1280.jpg" alt/> -->
            <v-row no-gutters class="flex-nowrap">
              <v-col cols="12">
                <v-card class="mobile-match-card" v-if="!isGameMaintenance('cricket', 'betswiz')" @click="accessGame('cricket', 'betswiz')" dark>
                  <v-row>
                    <v-col cols="12" class="ml-2 mt-2 mb-2 font-weight-bold d-flex">
                      <div class="matchUp" v-if="isMatchStarted(league)">
                        <div>{{ matchUp(league) }}</div>
                      </div>
                      <div class="matchUp-NS" v-else>
                        <div>{{ matchUp(league) }}</div>
                      </div>
                      <span class="ml-2 leagueName">
                        {{ league.league_name }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row class="mobile-detail-wrapper no-gutters">
                    <v-col cols="12" class="mobile-match-details match-date pl-3 pt-1">
                      {{ league.starting_at | utcToLocalTimeOnly }}
                    </v-col>
                    <v-col cols="12" class="mobile-match-details">
                      <v-row no-gutters>
                        <v-col cols="2" class="d-flex align-center justify-center pa-0">
                          <img :src="league.localteam_image" height="25" width="25" />
                        </v-col>
                        <v-col cols="6" class="pa-0 ">
                          <span class="team-title">{{ league.localteam_name }}</span>
                        </v-col>
                        <v-col cols="4" class="pa-0 d-flex" v-if="isMatchStarted(league)">
                          <span class="team-title">{{ league.localteam_dl_score ? league.localteam_dl_score : 0 }}</span>
                          <span class="team-title">/ {{ league.localteam_dl_wickets ? league.localteam_dl_wickets : 0 }} ({{ league.localteam_dl_overs ? league.localteam_dl_overs : 0 }})</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="mobile-match-details">
                      <v-row no-gutters>
                        <v-col cols="2" class="d-flex align-center justify-center pa-0">
                          <img :src="league.visitorteam_image" height="25" width="25" />
                        </v-col>
                        <v-col cols="6" class="pa-0 ">
                          <span class="team-title">{{ league.visitorteam_name }}</span>
                        </v-col>
                        <v-col cols="4" class="pa-0 " v-if="isMatchStarted(league)">
                          <span class="team-title">{{ league.visitorteam_dl_score ? league.visitorteam_dl_score : 0 }}</span>
                          <span class="team-title">/ {{ league.visitorteam_dl_wickets ? league.visitorteam_dl_wickets : 0 }} ({{ league.visitorteam_dl_overs ? league.visitorteam_dl_overs : 0 }})</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
                <!--                <v-row no-gutters>-->
                <!--                 <v-col>-->
                <!--                   <v-card>-->
                <!--                    <v-row>-->
                <!--                      <v-col cols="4" class="mobile-match-details">-->
                <!--                        {{ league.home_team }}-->
                <!--                      </v-col>-->
                <!--                      <v-col cols="4" class="mobile-match-details">-->
                <!--                        {{ league.match_date }}-->
                <!--                      </v-col>-->
                <!--                      <v-col cols="4" class="mobile-match-details">-->
                <!--                        {{ league.away_team }}-->
                <!--                      </v-col>-->
                <!--                    </v-row>-->
                <!--                   </v-card>-->
                <!--                 </v-col>-->
                <!--                </v-row>-->
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import stingFormat from 'string-format'
import { formValidator, uiHelper } from '@/util'
import {CACHE_KEY, SHARED} from '@/constants/constants'
import { CRICKET_MATCH, GAME_MATCHES_HIGHLIGHTS } from '@/store/game.module'
import { ROUTE_NAME } from '@/constants/route.constants'
import { locale } from '@/util/localization-helper'
import { orderBy, take } from 'lodash'
import moment from 'moment'
import {SEMI_TRANSFER} from "@/store/transfer.module";

export default {
  name: 'appHomeHighlight',
  data: () => ({
    storageGameProviderType: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_PROVIDER_TYPE}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    intervalId: null,
    isImageLoaded: false,
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    currentIndexes: 0,
    images: [
      {
        src: SHARED.MEDIA_SERVER_URL + '/banner/ambas/BB89_mobile.png',
        background: SHARED.MEDIA_SERVER_URL + '/banner/ambas/bb88_banner-GCJ.jpg',
        videoSource: 'https://www.youtube.com/embed/yV8OOraIC34?si=aa32ybr5_ptnxpjg'
      },
      {
        src: SHARED.MEDIA_SERVER_URL + '/banner/ambas/BB89_mobile.png',
        background: SHARED.MEDIA_SERVER_URL + '/banner/ambas/bb88_banner-CS.jpg',
        videoSource: 'https://www.youtube.com/embed/jsjsjwtS-_M?si=BMODOS7n6qms7HzT'
      },
      {
        src: SHARED.MEDIA_SERVER_URL + '/banner/ambas/BB89_mobile.png',
        background: SHARED.MEDIA_SERVER_URL + '/banner/ambas/bb88_banner-RK.jpg',
        videoSource: 'https://www.youtube.com/embed/wYOfcuueCpI?si=udBgUPbT6W6OK8qv'
      },
      {
        src: SHARED.MEDIA_SERVER_URL + '/banner/ambas/BB89_mobile.png',
        background: SHARED.MEDIA_SERVER_URL + '/banner/ambas/bb88_banner-AB.jpg',
        videoSource: 'https://www.youtube.com/embed/s1CYyQmbXcA?si=ZUpF4LFtAwAG8OlI'
      },
      {
        src: SHARED.MEDIA_SERVER_URL + '/banner/ambas/BB89_mobile.png',
        background: SHARED.MEDIA_SERVER_URL + '/banner/ambas/bb88_banner-MT.jpg',
        videoSource: 'https://www.youtube.com/embed/UwnS-ATONek'
      },
      {
        src: SHARED.MEDIA_SERVER_URL + '/banner/ambas/BB89_mobile.png',
        background: SHARED.MEDIA_SERVER_URL + '/banner/ambas/bb88_banner-NW.jpg',
        videoSource: 'https://www.youtube.com/embed/uHVsGorTAIo?si=WEWd8-bU65__Gxu7'
      }
      // {
      //   src: SHARED.MEDIA_SERVER_URL + '/banner/ambas/BB88_mobile.png',
      //   background: SHARED.MEDIA_SERVER_URL + '/banner/ambas/bb88_banner-DA.jpg',
      //   videoSource: 'https://www.youtube.com/embed/MYBQJZ-pBMk?si=eiQX-4ObsZDh1cHi'
      // }
      // Add more images as needed
    ],
    currentIndex: 0,
    itemsPerView: 3,
    highlights: null,
    routeName: ROUTE_NAME,
    desktopHighlights_1: [],
    desktopHighlights_2: [],
    currentHightlight_1: 0,
    currentHightlight_2: 0,
    startTime: SHARED.DEFAULT_START_TIME,
    endTime: SHARED.DEFAULT_END_TIME,
    currentCurrency: uiHelper.getCurrency()
  }),
  created() {
    this.getCricketMatches()
    if (this.currentCurrency != 'NPR') {
      this.getMatchesHighlights()
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    cricketMatches() {
      const cricketData = this.$store.state.game.cricketMatch.data;

      const startOfToday = moment().startOf('day');
      const endOfTomorrow = moment().add(1, 'day').endOf('day');

      // Define bad statuses
      const badStatuses = ['Aban.', 'Awarded', 'Postp.', 'Int.', 'Canl.', 'Cancl.', 'Delayed'];

      const filteredData = cricketData.filter(match => {
        const matchStart = moment(match.starting_at);
        const matchStatus = (match.status || '').toLowerCase(); // make sure safe

        // Skip matches with bad statuses
        if (badStatuses.some(status => status.toLowerCase() === matchStatus)) {
          return false;
        }

        // Special case: finished matches
        if (matchStatus === 'finished') {
          const now = moment();
          const matchEndTime = moment(match.starting_at);
          const fifteenMinutesAfter = matchEndTime.add(15, 'minutes');

          if (now.isAfter(fifteenMinutesAfter)) {
            return false; // more than 15 minutes passed after match finish, skip
          }
        }

        // Match must be between today and end of tomorrow
        return matchStart.isBetween(startOfToday, endOfTomorrow, null, '[]');
      });

      // Return first 20 results
      return filteredData.slice(0, 20);
    },
    currentImage() {
      return this.images[this.currentIndexes].src
    },
    currentBackgroundImage() {
      return this.images[this.currentIndexes].background
    },
    currentVideoSource() {
      return this.images[this.currentIndexes].videoSource
    },
    matchesHighlightsDesktop() {
      let filteredMatches = this.$store.state.game.matchesHighlights.filter(x => x.match_date >= this.startTime)
      filteredMatches = orderBy(filteredMatches, ['match_date'], ['asc'])
      const matchesPerPage = 3
      let startIndex = this.currentIndex * matchesPerPage
      let endIndex = startIndex + matchesPerPage
      const currentMatches = filteredMatches.slice(startIndex, endIndex)

      // Update button visibility
      const totalPages = Math.ceil(filteredMatches.length / matchesPerPage)
      const showNext = this.currentIndex < totalPages - 1
      const showPrev = this.currentIndex > 0

      return {
        currentMatches,
        showNext,
        showPrev
      }
    },
    matchesHighlights() {
      const endedStatuses = ['Finished', 'Stumps', 'Abandoned', 'Cancelled', 'No Result', 'Draw', 'Tie']

      if (this.$store.state.game.matchesHighlights && this.$store.state.game.matchesHighlights.length > 0) {
        let k = this.$store.state.game.matchesHighlights.filter(x => {
          // ✅ Skip if match is ended
          if (endedStatuses.includes(x.status)) return false

          // ✅ Keep if match_date >= this.startTime
          return x.match_date >= this.startTime
        })

        k = orderBy(k, ['match_date'], ['asc'])
        k = take(k, 7)

        const n = Math.ceil(k.length / 2)
        this.desktopHighlights_1 = k.slice(0, n)
        this.desktopHighlights_2 = k.slice(n)

        k = k.map(function (league) {
          let leagueTime = league.match_date.indexOf(' ') !== -1 ? league.match_date.split(' ')[1] : league.match_date
          let leagueDate = league.match_date.indexOf(' ') !== -1 ? league.match_date.split(' ')[0] : league.match_date

          league.matchTime = leagueTime.split(':')[0] + ':' + leagueTime.split(':')[1]
          league.matchDate = leagueDate

          return league
        })

        return k
      }

      return []
    }
  },
  /*watch: {
    matchesHighlights() {
      this.highlights = this.$store.state.game.matchesHighlights
      return this.highlights
    }
  },*/
  mounted() {
    this.startApiCallInterval()
    this.startImageRotation()
    const wrapper = this.$el.querySelector('.highlights-container');
    if (wrapper) {
      wrapper.addEventListener(
        'wheel',
         evt => {
           evt.preventDefault();
           // Prefer horizontal scroll deltaX if available, fallback to vertical deltaY
           const scrollAmount = evt.deltaX !== 0 ? evt.deltaX : evt.deltaY;
           wrapper.scrollLeft += scrollAmount * 1.5;
         },
         { passive: false }
      );
    }
    // const slider = this.$el.querySelector('.highlights-container');
    // if (slider) {
    //   let isDown = false;
    //   let startX;
    //   let scrollLeft;
    //
    //   slider.addEventListener('mousedown', (e) => {
    //     isDown = true;
    //     slider.classList.add('dragging');
    //     startX = e.pageX - slider.offsetLeft;
    //     scrollLeft = slider.scrollLeft;
    //   });
    //
    //   slider.addEventListener('mouseleave', () => {
    //     isDown = false;
    //     slider.classList.remove('dragging');
    //   });
    //
    //   slider.addEventListener('mouseup', () => {
    //     isDown = false;
    //     slider.classList.remove('dragging');
    //   });
    //
    //   slider.addEventListener('mousemove', (e) => {
    //     if (!isDown) return;
    //     e.preventDefault();
    //     const x = e.pageX - slider.offsetLeft;
    //     const walk = (x - startX) * 2; // *2 = scroll faster
    //     slider.scrollLeft = scrollLeft - walk;
    //   });
    // }
  },
  methods: {
    isGameMaintenance(gameType, providerCode) {
      if (
        this.storageGameProviderType == null ||
        this.storageGameProviderType.find(x => x.type == gameType) == undefined ||
        this.storageGameProviderType.find(x => x.type == gameType).providers.find(x => x.providerCode == providerCode) == undefined
      ) {
        return false
      } else {
        return this.storageGameProviderType.find(x => x.type == gameType).providers.find(x => x.providerCode == providerCode).isMaintenance
      }
    },
    //http://localhost:8802/playgame/betswiz/cricket?demo=0
    async accessGame(type, providerCode) {
      if (this.isLoggedIn) {
        let routeData = this.$router.resolve({
          name: ROUTE_NAME.LAUNCH_GAME_LOBBY,
          params: {
            provider: providerCode,
            lang: this.$route.params.lang,
            type: type
          },
          query: {
            demo: 0
          }
        })
        try {
          this.$ga.event('Game', 'Real Play', `${providerCode.toUpperCase()} - cricket`)
        } catch (err) {
          console.log(err)
        }
        await uiHelper.openNewTab(routeData.href, 'Game Play Lobby', 1440, 810)
        this.semiTransfer(providerCode)
        uiHelper.pushSportRadarRetargeting(null, type, providerCode)
      } else {
        this.goToLoginPage()
      }
    },
    goToLoginPage() {
      this.$router.push({
        name: ROUTE_NAME.LOGIN,
        params: { lang: this.$route.params.lang }
      })
    },
    semiTransfer(providerCode) {
      let obj = {
        to_wallet: providerCode
      }
      return this.$store.dispatch(`${SEMI_TRANSFER}`, { obj })
    },
    isMatchStarted(league) {
      const startedStatuses = [
        // General LIVE Statuses
        "LIVE", "PEN_LIVE", "OT", "SO",

        // Quarter-based sports (Basketball, American Football)
        "1st Quarter", "2nd Quarter", "3rd Quarter", "4th Quarter",

        // Half-based sports (Football, Rugby)
        "1st Half", "2nd Half", "HT", // Includes Half-Time

        // Innings-based sports (Cricket, Baseball)
        "1st Innings", "2nd Innings", "Super Over", "Innings Break",

        // Extra time & Penalty shootouts (Football)
        "Extra Time 1st Half", "Extra Time 2nd Half","Finished"
      ];

      return startedStatuses.includes(league.status);
    },
    startApiCallInterval() {
      // Set the interval based on the current time
      this.updateInterval()
    },

    // Update the interval for the API call based on the time range (called once during mounted)
    updateInterval() {
      const currentTime = this.getCurrentDateTime('BDT')
      const currentHour = currentTime.getHours()
      console.log('Current hour:', currentHour)

      // Check if the current time is between 5:00 PM and 2:00 AM
      if ((currentHour >= 17 && currentHour < 24) || (currentHour >= 0 && currentHour < 2)) {
        this.setApiCallInterval(60000) // Call every 1 minute (60,000 ms)
      } else {
        this.setApiCallInterval(120000) // Call every 2 minutes (120,000 ms)
      }
    },

    // Set the API call interval
    setApiCallInterval(interval) {
      // Ensure that only one interval is set
      if (this.intervalId) {
        console.log('Interval already set, not resetting')
        return
      }

      console.log('Setting interval for', interval)
      this.intervalId = setInterval(() => {
        console.log('Calling cricket matches at interval = ' + interval)
        this.getCricketMatches() // Fetch jackpot data at intervals
      }, interval)
    },

    // Method to calculate the current time in the given country code's timezone
    getCurrentDateTime(countryCode) {
      const currentDate = new Date()

      let timeZoneOffsetMinutes = 0

      // Determine the time zone offset based on the countryCode
      switch (countryCode) {
        case 'INR':
          timeZoneOffsetMinutes = 5 * 60 + 30 // 5 hours and 30 minutes ahead of UTC (India)
          break
        case 'NPR':
          timeZoneOffsetMinutes = 5 * 60 + 45 // 5 hours and 45 minutes ahead of UTC (Nepal)
          break
        case 'BDT':
          timeZoneOffsetMinutes = 6 * 60 // 6 hours ahead of UTC (Bangladesh)
          break
        // Add more cases for other countries if needed
        default:
          // Default to UTC (no offset)
          break
      }

      // Calculate the UTC time in milliseconds
      const utcTime = currentDate.getTime() + currentDate.getTimezoneOffset() * 60000

      // Calculate the target time using the UTC time and the specific offset
      const targetTime = new Date(utcTime + timeZoneOffsetMinutes * 60000)

      return targetTime
    },
    truncatedTeamName(teamName) {
      const words = teamName
        .split(' ')
        .slice(0, 3)
        .join(' ')
      if (teamName.split(' ').length > 3) {
        return words + '...'
      } else {
        return words
      }
    },
    matchUp(league) {
      // Normalize the status (remove periods and trim spaces)
      const normalizedStatus = league.status.replace(/\./g, "").trim().toUpperCase();

      const statusMap = {
        NS: "Upcoming",        // Not Started
        LIVE: "Live",          // Match is currently in progress
        HT: "Half-Time",       // Half-time
        FT: "Finished",        // Full-time
        AET: "After Extra Time", // Match ended after extra time
        PEN_LIVE: "Penalty Shootout", // Match in penalty shootout
        FT_PEN: "Finished (Penalties)", // Match finished after penalties
        POSTP: "Postponed",    // Match postponed
        CANC: "Canceled",      // Match canceled
        ABD: "Abandoned",      // Match abandoned
        ABAN: "Abandoned",     // Fix for "Aban." case
        SUSP: "Suspended",     // Match suspended
        INT: "Interrupted",    // Match temporarily stopped
        DELAYED: "Delayed",    // Match delayed
        TBA: "To Be Announced", // Match schedule not confirmed
        AWARD: "Awarded",      // Match awarded to a team
        WO: "Walkover",        // One team won by default
      };

      // Return the mapped status if available, otherwise return "Unknown Status"
      return statusMap[normalizedStatus] || league.status;
    },
    selectImage(index) {
      this.currentIndexes = index
    },
    startImageRotation() {
      this.isImageLoaded = true
      setInterval(() => {
        if (this.images.length > 0) {
          this.currentIndexes = (this.currentIndexes + 1) % this.images.length
        }
        if (this.currentIndexes >= this.images.length) {
          this.currentIndexes = 0 // Reset currentIndex to 0 if it exceeds the length of images array
        }
      }, 50000)
    },
    formatMatchDate(dateString) {
      const [datePart, timePart] = dateString.split(' ')
      const [year, month, day] = datePart.split('-')
      const [hour, minute] = timePart.split(':')

      const date = new Date(year, month - 1, day, hour, minute)
      const today = new Date()

      // Check if the date is today
      if (date.toDateString() === today.toDateString()) {
        // If it's today, return 'Today'
        return 'Today , ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      } else {
        // If it's not today, return the date and time
        return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) + ',' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      }
    },
    changeLanguage(language) {
      this.$store.dispatch(`${SHARED.LOADING}`)
      uiHelper.removeCookie('language')
      uiHelper.setCookie('language', language)
      window.location.reload()
    },
    getMatchesHighlights() {
      this.$store.dispatch(`${GAME_MATCHES_HIGHLIGHTS}`)
    },
    async getCricketMatches() {
      try {
        console.log('API call triggered')
        await this.$store.dispatch(`${CRICKET_MATCH}`)
      } catch (error) {
        console.error('Error fetching cricket matches', error)
      }
    },
    scrollLeft() {
      this.currentIndex--
    },
    scrollRight() {
      this.currentIndex++
    }
  },
  watch: {
    cricketMatches() {
      if (!this.$store.state.game.cricketMatch.success) {
        this.getCricketMatches()
      }
    }
  }
}
</script>

<style lang="scss">
.leagueName {
  font-size: 12px;
  color: black !important;
}
.matchUp {
  border-radius: 5px;
  display: flex;
  align-items: center;
  background-color: red;
  padding: 2px;
  color: #fff;
  font-size: 10px;
}
.matchUp-NS {
  border-radius: 5px;
  display: flex;
  align-items: center;
  background-color: black;
  padding: 2px;
  color: #fff;
  font-size: 10px;
}
.tabHeight {
  height: 320px !important;
}
.carousel-controls {
  position: absolute;
  bottom: 55px;
  left: 15px;
}

.control-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #d9d9d9; /* Default color */
  margin-left: 5px; /* Adjust as needed */
}

.control-dot.active {
  background-color: #ffce01; /* Active color */
}
// .v-card {
//     border-radius: 5px 0 0 5px !important;
// }
.circle-btn {
  border-radius: 50%; /* Make the button round */
  min-width: 40px !important;
  min-height: 40px !important;
  width: 40px; /* Adjust the size as needed */
  height: 40px; /* Adjust the size as needed */
  background-color: #0080f6 !important; /* Change the background color as needed */
  display: flex;
  justify-content: center;
  align-items: center;
}
.item {
  display: inline-block;
  padding: 10px;
  width: calc(100% / 3); /* Each item occupies 1/3 of the viewport width */
  /* Adjust styling for each item as needed */
}
.highlights-container-desktop {
  //overflow-x: scroll;
  //overflow-y: hidden;
  //white-space: nowrap;
  //max-width: 100vw;

  .border-top-left-radius {
    border-top-left-radius: 10px !important;
  }

  .border-top-right-radius {
    border-top-right-radius: 10px !important;
  }

  .border-bottom-left-radius {
    border-bottom-left-radius: 10px !important;
  }

  .border-bottom-right-radius {
    border-bottom-right-radius: 10px !important;
  }
}
.highlights-container::-webkit-scrollbar {
  height: 8px;
}
.highlights-container {
  cursor: grab;
  user-select: none; /* prevent text selection while dragging */
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  max-width: 100vw;
  -webkit-overflow-scrolling: touch; /* smooth on iOS */
  scroll-behavior: smooth; /* optional smooth scrolling */

  .border-top-left-radius {
    border-top-left-radius: 10px !important;
  }

  .border-top-right-radius {
    border-top-right-radius: 10px !important;
  }

  .border-bottom-left-radius {
    border-bottom-left-radius: 10px !important;
  }

  .border-bottom-right-radius {
    border-bottom-right-radius: 10px !important;
  }
}
.highlights-container.dragging {
  cursor: grabbing;
}
.matches-box {
  margin-bottom: 5px;

  .match-item {
    display: inline-block;
    width: 360px; // padding-right: 20px;
    margin: 0 20px 0 0;
  }

  .mobile-match-card {
    &.v-card {
      text-overflow: ellipsis;
      overflow: hidden;
      width: auto;
      white-space: nowrap;
      background-color: #ffce01;
      border-radius: 15px;
      color: #ffffff;
    }
  }

  .mobile-detail-wrapper {
    background-color: #fff;
    height: auto;
    min-height: 120px;
    display: flex;
    align-items: center;

    .mobile-match-details {
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: start;
    }

    .team-title {
      color: #000;
      font-size: 12px;
      white-space: break-spaces;
      overflow: hidden;
      text-align: center;
    }

    .match-date {
      color: #959595;
      height: 1.1rem;
    }
  }
}

@media (max-width: 599px) {
  .highlights-container {
    font-size: 14px;
  }

  .matches-box {
    .match-item {
      width: 300px;
    }
  }
}

.cricket-name-header {
  text-overflow: ellipsis;
  overflow: hidden;
  width: auto;
  white-space: nowrap;
  background-color: #ffce01 !important;
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}

@media screen and (min-width: 900px) {
  .team-title {
    font-size: 14px !important;
  }
  .matches-header {
    font-size: 25px;
  }
  .matches-box {
    .match-item {
      display: inline-block;
      width: 20%;
      margin: 0 20px 0 0;
    }
  }
}
</style>
